import { motion } from "framer-motion";

const Statement = () => (
  <section className="bg-background py-20 md:py-28">
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="max-w-[900px] mx-auto px-6 md:px-12 text-center"
    >
      <span className="inline-block border border-border rounded-full px-4 py-1.5 text-[10px] font-bold tracking-[.14em] uppercase text-muted-foreground mb-6">
        Our Position
      </span>
      <p className="font-display text-2xl md:text-[clamp(24px,3vw,36px)] font-light text-foreground leading-[1.5] italic">
        Most homeowners don't realize there's a difference between a flooring <em className="text-muted-foreground">salesman</em> and a flooring <strong className="font-semibold not-italic text-foreground">authority</strong>. Not until something goes wrong. We're the people you call when it does. And the people you should have <em className="text-primary not-italic font-medium">called first.</em>
      </p>
    </motion.div>
  </section>
);

export default Statement;
